<script setup lang="ts">
import type { NuxtError } from '#app'

const { error } = defineProps({
  error: Object as () => NuxtError
})

const url = window.location.origin
</script>

<template lang="pug">
  LayoutFlowStep.fin(
    :showBackButton="false"
  )
    template(#top)
      h1.text-3xl.font-bold.mb-2 Ein Fehler ist aufgetreten
      h2.text-lg.font-bold.mb-4.text-zinc-500 {{ error.statusCode }}: {{ error.statusMessage }}
  
    template(#content)
      UAlert(color="red", variant="soft")
        template(#title)
          p
            | Bei Fragen zur Ihrem Vorgang wenden Sie sich bitte an unseren Support:
            |
            a.text-sky-500(:href="`mailto:${useRuntimeConfig().public.email}`") {{ useRuntimeConfig().public.email }}
    template(#actions)
      UButton(
        :to="url"
      ) Zur Startseite
  </template>
